import React from 'react';
// import MERNm '../components/Home/MERN';
import MERNDetail from '../components/OnlineProgram/MERNDetail';



const Online = () => {
  return (
    <div>
        <MERNDetail></MERNDetail>
    </div>
  );
};

export default Online;
